import React, { useEffect } from 'react';
import quoteImg from '../../../assets/quote.svg';
import { StepV2ConfirmButton } from '../../common/v2/StepV2ConfirmButton';
import { MainButtonVariant } from '../../styledComponent/Buttons.style';
import {
  FullStaticScreen,
  FullStaticScreenContentWrapper,
  FullStaticScreenCtaWrapper,
  FullStaticScreenDescription,
  FullStaticScreenLabel,
  FullStaticScreenQuote,
  FullStaticScreenQuoteChar,
  FullStaticScreenQuoteSubtitle,
  FullStaticScreenTitle,
} from './PauseFullScreenStep.style';
import { PauseFullScreenStepProps } from './PauseFullScreenStep.types';
import { useAnalytics } from '../../../utils/analytics';

export const PauseFullScreenStep: React.FC<PauseFullScreenStepProps> = (props) => {
  const {
    title,
    description,
    label,
    mode = 'standard',
    nextStep,
    ctaButtonTitle,
    quote,
    quoteSubtitle,
    imgDesktop,
    imgMobile,
    isActive,
  } = props;

  const analytics = useAnalytics();

  useEffect(() => {
    if (isActive) {
      analytics.track(`view pause screen`);
      return window.scrollTo(0, 0);
    }
  }, [analytics, isActive]);

  const handleOnClick = () => {
    nextStep();
  };

  return (
    <FullStaticScreen imgDesktop={imgDesktop} imgMobile={imgMobile}>
      <FullStaticScreenContentWrapper>
        {mode === 'standard' && (
          <>
            {label && <FullStaticScreenLabel>{label}</FullStaticScreenLabel>}
            {title && <FullStaticScreenTitle>{title}</FullStaticScreenTitle>}
            {description && <FullStaticScreenDescription>{description}</FullStaticScreenDescription>}
          </>
        )}
        {mode === 'quote' && (
          <>
            <FullStaticScreenQuoteChar src={quoteImg} />
            {quote && <FullStaticScreenQuote dangerouslySetInnerHTML={{ __html: quote }} />}
            {quoteSubtitle && <FullStaticScreenQuoteSubtitle>{quoteSubtitle}</FullStaticScreenQuoteSubtitle>}
          </>
        )}
        <FullStaticScreenCtaWrapper>
          <StepV2ConfirmButton
            {...props}
            isButtonDisabled={false}
            isLoading={false}
            onClick={handleOnClick}
            ctaButtonTitle={ctaButtonTitle}
            variant={MainButtonVariant.Transparent}
          ></StepV2ConfirmButton>
        </FullStaticScreenCtaWrapper>
      </FullStaticScreenContentWrapper>
    </FullStaticScreen>
  );
};
